<template>
    <v-container grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <!--
                <icon-world class="animation-world world-component" :progressValue="100" :topLevelIndex="12"></icon-world>
                -->
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs2 sm1>
                <div class="display-flex">
                    <div class="center-by-margin">
                        <img @click="$router.push('fragen')"  class="ui-btn" src="icons/qa/ui/btnBackward.svg" />
                    </div>
                </div>
            </v-flex>
            <v-flex xs8 sm10>
                <p>Mit Klick auf die folgenden Themenfelder findest Du die L&ouml;sungen, die auf Basis Deiner
Antworten für Deine derzeitige Lebenssituation wichtig sind. W&auml;hle dort über den
blauen Button aus, was Du schon hast und was Dich nicht interessiert.</p>

                <!--
                <p>Unsere Empfehlungen</p>
                <p>Schau mal, mit nachstehenden Produkten solltest du möglichen Stolperfallen in deinem Leben aus dem Weg gehen können.
                    Wähle aus, was Du schon hast und was Dich nicht interessiert.</p>
                -->
            </v-flex>
            <v-flex xs2 sm1>
                <div class="display-flex">
                    <div class="center-by-margin">
                        <img @click="$router.push('mailrequest')"  class="ui-btn" src="icons/qa/ui/btnForward.svg" />
                    </div>
                </div>
            </v-flex>
        </v-layout>

        <v-layout class="container">
            <v-flex
                    xs12 md8 offset-md2>
                <v-expansion-panel multiple v-model="topicPanelOpen" outset>
                    <v-expansion-panel-content
                            class="fill-height elevation-3  "
                            v-for="t in topics"
                            :key="t.index"
                            v-if="productsWithPointsListByTopic(t.index).length > 0"
                    >

                        <template v-slot:header>
                            <div>{{ t.label }}</div>
                        </template>
                    <topic :topic="t" ></topic>
                        </v-expansion-panel-content>
                    </v-expansion-panel>

            </v-flex>
        </v-layout>
    </v-container>
</template>


<script>
    import { mapGetters } from "vuex";
    import IconWorld from "./IconWorld";
    import Topic from "./Topic";

    export default {
        name: "RecommendationByTopic",
        components: { IconWorld, Topic },
        data(){
            return {
                'topicPanelOpen': [0]
            }
        },
        computed: {
            ...mapGetters("qa", {
                topics: 'getTopics',
                productsWithPointsListByTopic: 'getRecommendedProductsWithPointsByTopic'
            })
        },
        mounted(){
        }
    }
</script>

<style scoped>

</style>
